module.exports = __webpack_public_path__ + "static/media/pencil.99e63ce4.svg";